<template>
  <div class="field">
    <label
      v-if="label"
      class="label"
    >
      {{ label }}
      <FieldHelp :text="help" />
    </label>
    <p
      v-if="extraText"
      class="with-space"
    >
      {{ extraText }}
    </p>
    <div class="control">
      <div
        v-for="opt in options"
        :key="opt.value"
      >
        <label class="radio my-extra-spacing">
          <input
            :id="id + '-' + opt.value"
            type="radio"
            class="my-extra-spacing"
            :name="id"
            :value="opt.value"
            :checked="opt.value==maybeValue"
            @change="handleChange"
          >
          {{ opt.label }}
        </label>
        <br>
      </div>
    </div>
  </div>
</template>

<script>
import FieldHelp from './FieldHelp.vue';

export default {
  components: {
    FieldHelp,
  },
  props: {
    id: {
      type: String,
      default: 'unique-id',
    },
    label: {
      type: String,
      default: '',
    },
    help: {
      type: String,
      default: '',
    },
    extraText: {
      type: String,
      default: '',
    },
    modelValue: Object, // null or { value: 'one', ok: true },
    options: {
      type: Array,
      default() {
        return [
          { value: 'one', label: 'option one' },
          { value: 'two', label: 'option two' },
        ];
      },
    },
  },
  emits: ['update:modelValue'],
  computed: {
    maybeValue() {
      if (this.modelValue == null) return null;
      return this.modelValue.value;
    },
  },
  methods: {
    handleChange(event) {
      const { value } = event.target;
      this.$emit('update:modelValue', {
        value,
        ok: true,
      });
    },
  },
};
</script>

<style scoped>
label.my-extra-spacing {
  margin-bottom: 0.5em;
}
input.my-extra-spacing {
  margin-right: 0.5em;
}
</style>
